import React, { useEffect } from "react";
import Axios from "axios";
import * as Constants from "../../../../../consts/Constants.js";
import Style from "../../../../../styles/js/StyleCallList.js";
import CircularProgress from '@mui/material/CircularProgress';
import MaterialTable from "material-table";
import { useRouteMatch, withRouter } from "react-router-dom";
import { formatDateDDMMYYYYHHMM } from "../../../../../plas/utils";

function CallApplications( { history, callId } ) {


  const style = Style();
  const [loading, setLoading] = React.useState(true);
  const [tableData, setTableData] = React.useState([]);
  const [call, setCall] = React.useState(null);

  let { url } = useRouteMatch();

  const states = ["Abierto", "Enviado", "Cancelado", "Recepcionado", "Rechazado"]

  const getCall = () => {
    Axios.get(Constants.FINAL_URL_CALLS + "/" + callId)
    .then((response) => {
        let data = response.data
        setCall(data);
    })
    .catch((error) => {})
  }

  const getApplications = () => {
    Axios.get(Constants.FINAL_URL_CALLS + "/" + callId + "/applications")
    .then((response) => {
        let data = response.data
        setTableData(data);
    })
    .catch((error) => {})
    .then(() => {setLoading(false)})
  }

  const goApplication = (applicationId) => {
    history.push(`${url}/` + applicationId);
  }

  useEffect(() => {
    getApplications();
    getCall();
  }, []);

  return (
    <div className={style.box} >
      { loading ? 
        (
          <div style={{color:Constants.COLOR_PRIMARY}}>
            <CircularProgress color="inherit" />
          </div>
        ) : 
        (
          <MaterialTable
            options={{
              pageSize: 10,
              draggable: false,
              sorting: true,
              search: true,
              filtering: true,
              actionsColumnIndex: -1,
              tableLayout: 'auto',
              actionsCellStyle: { width: "5%"},          
              rowStyle: {
                fontSize: 15,
              }
            }}
            localization={{
              pagination: {
                labelDisplayedRows: "{from}-{to} de {count}",
                labelRowsPerPage: "Filas por página",
                labelRowsSelect: "Filas",
                firstAriaLabel: "Primera página",
                firstTooltip: "Primera página",
                previousAriaLabel: "Página anterior",
                previousTooltip: "Página anterior",
                nextAriaLabel: "Próxima página",
                nextTooltip: "Próxima página",
                lastAriaLabel: "Última página",
                lastTooltip: "Última página",
              },
              toolbar: {
                nRowsSelected: "{0} filas(s) seleccionadas",
                searchTooltip: "Buscar",
                searchPlaceholder: "Buscar",
              },
              header: {
                actions: "Acciones",
              },
              body: {
                emptyDataSourceMessage: "No hay postulaciones para mostrar",
                filterRow: {
                  filterTooltip: "Filtrar",
                }
              },
            }}
            actions={[{
                icon: "launch",
                tooltip: "Abrir",
                width: "100px",
                onClick: (event, rowData) => { goApplication(rowData.id); },
              },
            ]}
            title={"Postulaciones" + ((call == null) ? "" : " a " + call.name) }
            columns={[
              { title: "Código", filtering: false, field: "id", render: (application) => { return `#${application.id}`; },  cellStyle: {width:"5%"}, headerStyle:{width:"5%"} },
              { title: "Apertura",filtering: false, field: "userProfile.creationTime", render: (application) => { return formatDateDDMMYYYYHHMM(application.creationTime); }, cellStyle: {width:"15%"}, headerStyle:{width:"15%"} },
              { title: "Estado", lookup: { 0: `${states[0]}`, 1: `${states[1]}`, 2: `${states[2]}`, 3: `${states[3]}`, 4: `${states[4]}` }, field: "state", render: (application) => { return `${states[application.state]}`; }, cellStyle: {width:"10%"}, headerStyle:{width:"10%"} },
              { title: "Modificación", filtering: false, field: "userProfile.creationTime", render: (application) => { return formatDateDDMMYYYYHHMM(application.creationTime); }, cellStyle: {width:"15%"}, headerStyle:{width:"15%"} },
              { title: "Nombre", filtering: false, field: "userProfile.name", cellStyle: {width:"15%"}, headerStyle:{width:"15%"} },
              { title: "Apellido", filtering: false, field: "userProfile.lastName", cellStyle: {width:"15%"}, headerStyle:{width:"15%"}  },
              { title: "Género", filtering: false, field: "userProfile.gender", render: (application) => { if (application.userProfile == null) return "-"; else if (application.userProfile.gender === 0) return 'Hombre'; else if (application.userProfile.gender === 1) return "Mujer"; else return "Otro"; }, cellStyle: {width:"10%"}, headerStyle:{width:"10%"} },
              { title: "Teléfono", filtering: false, field: "userProfile.phoneNumber", render: (application) => { if (application.userProfile != null && application.userProfile.phoneNumber != null) return `${application.userProfile.phoneNumber}`; else return "-" }, cellStyle: {width:"10%"}, headerStyle:{width:"10%"} },
            ]}
            data={tableData}/>)
      }
    </div>

  );
}

export default withRouter(CallApplications);
